import { API_URLS } from "shared/config/api/urlsConfig";
import { getEnvironment } from "shared/utils/getEnvironment";

export type TrackingWebhookEvent = "search" | "searchEnd" | "redirect";

const TRACKING_WEBHOOK_URLS: Record<TrackingWebhookEvent, string> = {
  search: API_URLS.trackingSearchWebhook,
  searchEnd: API_URLS.trackingSearchEndWebhook,
  redirect: API_URLS.trackingRedirectWebhook,
};

/**
 * Envia para o n8n o mesmo objeto que vai para o `dataLayer`, para a Voopter
 * ter uma base própria de eventos e não depender só do Google Analytics.
 *
 * Só envia em produção: as URLs do n8n são de produção e eventos de
 * desenvolvimento/staging sujariam a base.
 *
 * Nunca lança nem gera rejeição não tratada (o Sentry capturaria e gastaria
 * cota). `text/plain` evita o preflight de CORS e `keepalive` deixa o envio
 * terminar depois que a página `/redirect` sai para o parceiro.
 */
export const sendTrackingWebhook = (
  event: TrackingWebhookEvent,
  payload: Record<string, unknown>,
): void => {
  try {
    if (typeof window === "undefined" || getEnvironment() !== "production") {
      return;
    }

    fetch(TRACKING_WEBHOOK_URLS[event], {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify(payload),
      keepalive: true,
    }).catch(() => undefined);
  } catch {
    // Tracking nunca pode afetar o fluxo do usuário.
  }
};
